<template>
  <div>
    <v-text-field
      :v="v"
      :value="ret_date"
      label="Return Date"
      hint="YYYY-MM-DD format"
      mask="####-##-##"
      :return-masked-value="true"
      :clearable="false"
      :show-current="false"
      @input="mInputRetDate"
      @click:append="hideCalRet"
      @focus="calRet = true"
      :append-icon="calRet ? 'close' : ''"
      outline
    ></v-text-field>
    <v-date-picker
      ref="ret_date_picker"
      v-show="calRet === true"
      v-model="ret_date"
      type="date"
      full-width
      :landscape="false"
      format="yyyy-MM-dd"
      :allowedDates="enabledDatesReturn"
      :clearable="true"
      max-width="250px"
      @input="handleInput()"
      :reactive="true"
    ></v-date-picker>
  </div>
</template>

<script>
import Shared from "@/mixins/Shared";

export default {
  name: "SelectReturnDate",
  props: {
    v: {
      type: Object,
      required: false
    }
  },
  mixins: [Shared],
  data: () => ({
    hideRetCalBtn: true,
    calRet: false
  }),
  methods: {
    handleInput() {
      this.dpInputRet();
      this.calRet = false;
    }
  }
}
</script>
